import axiosInstanceBuilder from "../config/axios/axiosInstanceBuilder";
import { useFetch } from "../config/axios/useFetch";
import axios from "axios";
const baseUrl = process.env.REACT_APP_API_DEV_URL;
const DEFAULT_ENDPOINT = "/users";
const UBA_ENDPOINT = "/uba/users";

const createAxiosPromise = ({
  UBAtoken,
  firstName,
  lastName,
  acceptedPolicy,
}) => {
  const apiPersonalInfo = {
    first_name: firstName,
    last_name: lastName,
    accepted_policy: acceptedPolicy,
  };

  const isUbaUser = Boolean(UBAtoken);
  const url = isUbaUser
    ? `${baseUrl}${UBA_ENDPOINT}?tk=${UBAtoken}`
    : `${baseUrl}${DEFAULT_ENDPOINT}`;

  const axiosClient = isUbaUser ? axios : axiosInstanceBuilder(baseUrl);

  return axiosClient.patch(url, apiPersonalInfo);
};

export const useUpdatePersonalInfo = () => {
  const { fetchApi } = useFetch(createAxiosPromise, false);

  const handleUpdatePersonalInfo = async (personalInfo) => {
    const response = await fetchApi(personalInfo);
    const { data, ...rest } = response;
    return { data, ...rest };
  };

  return { handleUpdatePersonalInfo };
};
